import React from "react";
import { Link } from "react-router-dom";
import SeoHead from "@/components/SeoHead";

/**
 * Real 404 page — returns a noindex meta so GSC doesn't flag soft-404s.
 * (We can't actually return an HTTP 404 from a static SPA, but Google
 * treats `noindex` + "not found" content as a true 404 for Coverage.)
 */
export const NotFound = () => (
  <div className="App min-h-screen" data-testid="not-found-page">
    <SeoHead
      title="Page not found — Kerala Speaks"
      description="The page you tried to open doesn't exist on Kerala Speaks."
      canonical="/404"
      noindex
    />
    <section className="max-w-3xl mx-auto px-5 sm:px-6 md:px-12 pt-16 md:pt-24 pb-24">
      <p className="text-xs md:text-sm uppercase font-bold tracking-[0.4em] text-neutral-600 mb-5">
        ★ 404 ★
      </p>
      <h1
        className="font-display uppercase leading-[0.85] tracking-tighter"
        style={{ fontSize: "clamp(3rem, 8vw, 6rem)" }}
        data-testid="not-found-title"
      >
        Page not found.
      </h1>
      <p className="mt-6 max-w-xl text-base md:text-lg font-medium leading-relaxed">
        The link you followed may be broken, or the page may have been removed.
      </p>
      <div className="mt-8 flex flex-wrap gap-3">
        <Link
          to="/"
          className="brutal-btn"
          style={{ background: "#0A0A0A", color: "#FF9933", borderColor: "#0A0A0A" }}
          data-testid="not-found-home-btn"
        >
          ← Back home
        </Link>
        <Link
          to="/previous-polls"
          className="brutal-btn"
          style={{ background: "#FDFBF7", color: "#0A0A0A", borderColor: "#0A0A0A" }}
          data-testid="not-found-archive-btn"
        >
          See the previous poll
        </Link>
      </div>
    </section>
  </div>
);

export default NotFound;
